import { memo } from "react"
import { HStack, Input, Flex } from "@chakra-ui/react"
import { Box, Circle, Float, IconButton, Text, Heading } from "@chakra-ui/react"
import { InputGroup } from "@/components/ui/input-group"
import { LuSearch, LuShoppingCart, LuMessageCircle, LuHouse, LuMenu } from "react-icons/lu"
import { useCart } from "contexts/cart"
import { useNavigate } from "react-router"
import { useApp } from "contexts/app";
import { useStore } from "contexts/store";
import { useChat } from "contexts/chat";
import ProductService from "@/services/product"


const Header = () => {
    let navigate = useNavigate();
    const { cart } = useCart();
    const { store } = useStore()
    const { openChat, hasChatEntry, unreadCount } = useChat();
    const { showProductSearch, setShowProductSearch, pageTitle, showMenu, setShowMenu } = useApp();
    return (
        <div>
            <Flex gap="4">
                <Flex grow={1} alignItems={"center"} minW="0">
                    <IconButton variant="ghost" flexShrink={0} onClick={e => setShowMenu(true)}>
                        <LuMenu></LuMenu>
                    </IconButton>
                    <Heading lineClamp={1} overflow="hidden" minW="0">{pageTitle}</Heading>
                </Flex>
                <Flex gap="4">
                    <Flex alignItems={"center"}>
                        <IconButton variant="ghost" onClick={e => setShowProductSearch(true)}>
                            <LuSearch></LuSearch>
                        </IconButton>

                    </Flex>
                    <Flex alignItems={"center"}>
                        <div style={{ position: "relative" }}>
                            <IconButton
                                variant="ghost"
                                disabled={!hasChatEntry}
                                onClick={e => {
                                    if (!hasChatEntry) return;
                                    openChat();
                                }}
                            >
                                <LuMessageCircle></LuMessageCircle>
                            </IconButton>
                            {unreadCount > 0 && (
                                <div style={{ position: "absolute", top: -6, right: -4, minWidth: 18, height: 18, borderRadius: 9, backgroundColor: "#e53e3e", color: "white", fontSize: 11, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 4px", fontWeight: 700 }}>
                                    {unreadCount > 99 ? "99+" : unreadCount}
                                </div>
                            )}
                        </div>
                    </Flex>
                    <Flex alignItems={"center"}>
                        <div>

                            {/* {cart &&
                                <Circle size="5" bg="red" color="white">
                                    {cart.total_item}
                                </Circle>
                            } */}
                            <IconButton onClick={e => navigate("/cart")}>
                                <div style={{ position: "relative" }}>

                                    <LuShoppingCart></LuShoppingCart>
                                    {cart &&
                                        <div style={{ position: "absolute", top: -12, right: -7 }}>{cart.total_item}</div>
                                    }

                                </div>

                            </IconButton>

                        </div>


                    </Flex>

                </Flex>
            </Flex>


        </div>
    )
}

export default memo(Header)